import { createSlice } from '@reduxjs/toolkit';
import { CONSTANTS } from 'common/constants';
import { QItem } from 'types/guide-tool';
import QStart from 'assets/json/start.json';
import QNewspaper from 'assets/json/newspaper.json';
import QArts from 'assets/json/arts.json';
import QFilms from 'assets/json/film-games.json';
import QBroadcasting from 'assets/json/broadCasting.json';
import QOnlineContent from 'assets/json/online-content.json';
import QPostalServices from 'assets/json/postal.json';
import QTelecomFirst from 'assets/json/telecom.json';
import QTelecomSecond from 'assets/json/telecom2.json';
import QPublications from 'assets/json/publications.json'
import { goScrollTop } from 'utils/windows';

interface IState {
    questions: QItem[];
    status: string;
    curValue: string | string[];
}

const initialState: IState = {
    questions: [],
    status: CONSTANTS.IDLE,
    curValue: ''
};

export const guidedToolSlice = createSlice({
    name: 'guidedTool',
    initialState,
    reducers: {
        setCurValue(state, action) {
            state.curValue = action.payload;
        },
        resetQuestion(state) {
            if (state.questions.length > 0) {
                const startQ = state.questions[0];
                startQ.value = '';
                state.questions = [startQ];
            }
            goScrollTop();
        },
        changeResponse(state, action) {
            const id = action.payload;
            const qTemp = [...state.questions];
            const index = qTemp.findIndex((item) => item.id === id);
            if (index > -1) {
                qTemp.splice(index + 1);
                qTemp[index].value = '';
                state.questions = qTemp;
            } else {
                qTemp.splice(1);
                qTemp[0].value = '';
                state.questions = qTemp;
            }
        },
        fetchQuestion(state, action) {
            const { qID, value, expect, expectOthers } = action.payload;
            const GuidedQuestions: QItem[] = [
                ...QStart,
                ...QNewspaper,
                ...QArts,
                ...QFilms,
                ...QBroadcasting,
                ...QOnlineContent,
                ...QPostalServices,
                ...QTelecomFirst,
                ...QTelecomSecond,
                ...QPublications
            ];

            const notFound: QItem = {
                id: 'unknown',
                require: '',
                info: 'Not Found',
                result: true
            };

            const qTemp = state.questions.map((qInfo: QItem) => {
                if (qInfo.id === qID) {
                    qInfo.value = value;
                }
                return qInfo;
            });

            if (qID === 'start' && !value) {
                const question = GuidedQuestions.find((item: QItem) => item.require === qID);
                qTemp.push(question || notFound);
            } else {
                let question = notFound;
                const id = `q-${qID}:`;
                if (!!value && typeof value === 'string') {
                    const target = `00${value}`.slice(-2);
                    const questionTemp = GuidedQuestions.find((item: QItem) => {
                        const requireList = item.require.split('|');
                        return requireList.some((req: string) => {
                            const reqItem = req.split(':');
                            if (reqItem.length < 2) return false;
                            return req.includes(id) && reqItem[1].includes(target);
                        });
                    });
                    if (questionTemp) question = questionTemp;
                }

                if (!!value && Array.isArray(value)) {
                    let target = '';
                    let targetOthers = '';
                    expect?.forEach((val: string) => {
                        const valArray = val.split(',');
                        const checkTarget = value.every((elem: string) => valArray.includes(`00${elem}`.slice(-2)));
                        if (checkTarget) target = val;
                    });

                    expectOthers?.forEach((val: string) => {
                        const valArray = val.split(',');
                        const checkTarget = value.some((elem: string) => valArray.includes(`00${elem}`.slice(-2)));
                        if (checkTarget && !targetOthers) targetOthers = val;
                    });

                    const questionTemp = GuidedQuestions.find((item: QItem) => item.require?.includes(id) && item.require.includes(target));
                    if (!!questionTemp && !!target) {
                        question = questionTemp;
                    } else {
                        const questionOthers = GuidedQuestions.find(
                            (item: QItem) => !!targetOthers && item.require?.includes(id) && item.require.includes(targetOthers)
                        );
                        if (questionOthers) question = questionOthers;

                        const questionMixed = GuidedQuestions.find(
                            (item: QItem) => item.require?.includes(id) && item.require.includes('mixed')
                        );
                        if (questionMixed && !questionOthers) question = questionMixed;
                    }
                }
                qTemp.push(question);
            }
            state.questions = qTemp;
            state.status = CONSTANTS.FULFILLED;
        }
    }
});

export const { setCurValue, resetQuestion, changeResponse, fetchQuestion } = guidedToolSlice.actions;

export const selectQuestions = (state: any) => state.guidedTool;
export const selectValue = (state: any) => state.guidedTool.curValue as string | string[];

export default guidedToolSlice.reducer;
